/**
 * Eén overzicht voor secretaris, organisatie-beheerder, superbeheerder en organisatie-lezers:
 * alle adresboekkaarten (alle entity_kind), met zoeken en filteren.
 */
import type { User } from "@domaddress/shared";
import ContactsPage from "./ContactsPage";
import { ALLE_CONTACTEN_API } from "../lib/contactApiPaths";

export default function AlleContactenPage({ user }: { user: User | null }) {
  return (
    <ContactsPage
      user={user}
      apiPath={ALLE_CONTACTEN_API}
      title="Alle contacten"
      singularLabel="contact"
      pluralLabel="contacten"
      importPath=""
      pageKey="alle-contacten"
    />
  );
}
